<template>
	<div class="acessar-ata-itens">
		<menu-acoes
			class="botao-tamanho-arp"
			:nome-botao="placeholder"
			:nome="placeholder"
			cor-icone="--v-error-base"
			icone-secondary="arrow_drop_down"
			:outlined="true"
			:block="block"
			corDeFundo="grey"
			:acoes-menu="itens"
			tamanho-icone-menu="18px"
			@estornar-itens="$emit('estornar-itens')"
		>
		</menu-acoes>
	</div>
</template>
<script>
import { permissoes } from '@/core/constants'

export default {
	name: 'acessar-pedido-itens-btn-mais-acoes',
	props: {
		block: {
			type: Boolean,
		},
		permissoesEmMassa: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			placeholder: 'MAIS AÇÕES',
			itens: [
				{
					titulo: 'Estornar Itens',
					icone: {
						nome: 'mdi-clipboard-arrow-left',
					},
					evento: 'estornar-itens',
					authorization: permissoes.pedidoUtilizacaoItemEstornar,
					isVisible: this.permissoesEmMassa.estornar,
				},
			],
		}
	},
}
</script>
<style lang="stylus"></style>
